const isObject = value => value instanceof Object && !Array.isArray(value) && !(value instanceof Date);
export const getDefaultErrors = (form, errors={}, level=1) =>
{
    console.assert(form instanceof Object);
    console.assert(errors instanceof Object);
    if (level===1)
    {
        errors.non_field_errors = [];
    }
    Object.entries(form).forEach(([key,value]) =>
    {
        errors[key] = isObject(value) ? getDefaultErrors(value, {}, level+1) : [];
    });
    return errors;
};

export const updateProps = (dest, src) =>
{
   // console.assert(dest instanceof Object, `Dest is not an object, ${dest}`);
   // console.assert(src instanceof Object, `Source is not an object, ${dest}`);
   Object.entries(src).forEach(([key,value]) =>
   {
      if (isObject(value))
      {
         dest[key] = dest[key]==null ? {} : dest[key];
         updateProps(dest[key], value)
      }
      else
      {
         dest[key] = value;
      }
   });
};